var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSigner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.067 1.625a2.175 2.175 0 1 0 0 4.35 2.175 2.175 0 0 0 0-4.35ZM4.642 3.8a3.425 3.425 0 1 1 6.85 0 3.425 3.425 0 0 1-6.85 0ZM3.335 10.268A6.692 6.692 0 0 1 14.758 15a.625.625 0 0 1-.625.625H2A.625.625 0 0 1 1.375 15c0-1.775.705-3.477 1.96-4.732Zm4.732-.71a5.442 5.442 0 0 0-5.406 4.817h10.811a5.442 5.442 0 0 0-5.405-4.817Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSigner);
export default __webpack_public_path__ + "static/media/icon-signer.4901813f7964325a0cd6549df39eddd4.svg";
export { ForwardRef as ReactComponent };